import { graphql } from 'gatsby';
import { getKey } from '../../../helpers';

/**
 * RawHtml widget definition
 * @param {Object} props of the widget
 * @param {string} locale of the props
 * @returns {Object} widget definition
 */
export const rawhtml = function rawHtml(props, locale, pageUri) {
  return {
    page_uri: pageUri,
    key: getKey(props, 'key'),
    content: getKey(props, `content_${locale}`)
  };
}

export default function rawhtmlProvider(props, locale, pageUri) {
  const key = getKey(props, 'key');
  return {
    locale,
    pageUri,
    rawHtmlId: key
  };
}



/**
 * GraphQL query
 */
export const query = graphql`
  fragment RawHtmls on StrapiWidgetrels {
    rawhtml {
      key: id
      content_en
      content_es
      widgetPosition
    }
  }
`;
